import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { Http } from '@angular/http';
import { RequestBuilder } from '../classes/request-builder';
import { Observable } from 'rxjs';
import * as Enum from '../utils/enums';

@Injectable()
export class PaymentService extends BaseService {

  constructor(http: Http) {
    super(http)
  }

  /**
   * attivita save pagamento
   * @param reqBuilder 
   */
  save(reqBuilder?: RequestBuilder): Observable<any> {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost('pagamentoContratto/save', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * attivita delete pagamento
   * @param reqBuilder 
   */
  delete(reqBuilder?: RequestBuilder): Observable<any> {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost('pagamentoContratto/delete', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
  * upload file
  * @param file file upload
  * @param pagamentoId id of pagamento
  * @param nomeFile name of file
  */
  uploadAllegatoPagamento(file: any, nomeFile: string, pagamentoId: string): Observable<any> {
    return this.doUploadPagamento('allegato/savePagamentoContratto', file, Enum.CONTENT_TYPE_ENUM.APPLICATION_OCTET_STREAM, pagamentoId, nomeFile)
  }
}
